<script setup lang="ts">
import { reformatDateString } from '@/helpers/dates'
import { formatToFinnishCurrency } from '@/helpers/formatters'
import { useI18n } from 'vue-i18n'

interface Props {
  /** The payslip input data */
  payslipInput: PayslipInput
}

defineProps<Props>()

const { t } = useI18n()
</script>

<template>
  <div class="flex flex-col gap-y-4 sm:flex-row">
    <div class="flex-1">
      <p>{{ t('salary.labels.withholding_percent') }}</p>
      <p>{{ payslipInput.withholding_percent }}</p>
    </div>
    <div class="flex-1">
      <p>{{ t('salary.labels.additional_withholding_percent') }}</p>
      <p>{{ payslipInput.additional_withholding_percent }}</p>
    </div>
  </div>

  <div class="flex flex-col gap-y-4 sm:flex-row">
    <div class="flex-1">
      <p>{{ t('salary.labels.income_limit') }}</p>
      <p>{{ formatToFinnishCurrency(payslipInput.income_limit ?? 0) }}</p>
    </div>
    <div class="flex-1">
      <p>{{ t('salary.labels.income_tax_card_date') }}</p>
      <p>
        {{ reformatDateString(payslipInput.income_tax_card_date ?? '') }}
      </p>
    </div>
  </div>
</template>
